// src/hooks/useResponsive.ts
import { useTheme, useMediaQuery } from "@mui/material";
export const useResponsive = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isBelow330 = useMediaQuery("(max-width:329.95px)");
    const isBelow370 = useMediaQuery("(max-width:405px)");
    const isIpad = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const is1024to1200 = useMediaQuery("(min-width:1024px) and (max-width:1200px)");
    const isMobileIpadNavigation = useMediaQuery(theme.breakpoints.down("lg"));
    const is1300to1900 = useMediaQuery("(min-width:1300px) and (max-width:1900px)");
    return {
        isBelow330,
        isBelow370,
        isMobile,
        isIpad,
        is1024to1200,
        is1300to1900,
        isMobileIpadNavigation,
    };
};
